// extracted by mini-css-extract-plugin
export default {"record_dropdown":"RecordDropdown_record_dropdown__lXHgH","options":"RecordDropdown_options__IXDts","dark":"RecordDropdown_dark__v5quW"};